import { isCurrentDraftContext } from '@/features/coach-review/composerDrafts';
import { ResourceMediaPlayback } from '@/features/playback/ResourceMediaPlayback';
import { resourceVideoSelection, resourceVideoSourceKey, type ResourceVideoSource } from './resourceVideoSource';

/** The editor retains its write-capable generation fence and canvas-owned ref.
 * Shared read playback never manufactures or weakens an editor context. */
export function ResourceVideoPlayback({source,videoRef,controls=false,onUnavailable}:{
  source:ResourceVideoSource|null;videoRef(el:HTMLVideoElement|null):void;controls?:boolean;onUnavailable?():void;
}) {
  if(!source||!isCurrentDraftContext(source.scope))return <div className="absolute inset-0 flex items-center justify-center text-paper/75" role="status">Loading the selected recording…</div>;
  return <ResourceMediaPlayback key={resourceVideoSourceKey(source)} scope={source.scope}
    selection={resourceVideoSelection(source)} videoRef={videoRef} controls={controls}
    onUnavailable={onUnavailable} testId="telestrator-video"/>;
}
